import { Box } from "@chakra-ui/react";
import type {
  ContributingEntityQualificationResponseDto,
  SelectionCriterionDto,
} from "../../../../../autogen/bff-api";
import { StepNavigation } from "../../../../../common/StepNavigation";
import { ContributingQualificationCard } from "../ContributingQualificationCard";

interface Props {
  selectionCriteria: SelectionCriterionDto[];
  responses: ContributingEntityQualificationResponseDto[];
  onChange: (next: ContributingEntityQualificationResponseDto[]) => void;
  readOnly: boolean;
  previousStep?: () => void;
  nextStep?: () => void;
  nextStepLabel?: string;
}

export const ContributionQualificationStep = ({
  selectionCriteria,
  responses,
  onChange,
  readOnly,
  previousStep,
  nextStep,
  nextStepLabel,
}: Props) => (
  <Box pb="8" pt="6">
    <ContributingQualificationCard
      selectionCriteria={selectionCriteria}
      responses={responses}
      onChange={onChange}
      readOnly={readOnly}
    />
    <StepNavigation onPrevious={previousStep} onNext={nextStep} nextLabel={nextStepLabel} />
  </Box>
);
